import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { CenterScreenComponent, DocumentForm } from '../../components';
import { useDocumentQuery, useMeQuery } from '../../generated/graphql';

interface EditDocumentScreenParams {
    id: string;
}

type EditDocumentScreenProps = RouteComponentProps<EditDocumentScreenParams>;

export const EditDocumentScreen: React.FC<EditDocumentScreenProps> = ({ match }) => {
    const id = match.params.id;
    const { data, loading, refetch } = useDocumentQuery({ variables: { id: +id } });

    const { text, attachmentIds, additionalField, documentTypeId } = data?.document || {};
    const parsedAdditionalField = JSON.parse(additionalField || '{}');

    const initialValues = { text, documentTypeId, ...parsedAdditionalField };

    if (loading) {
        return <CenterScreenComponent>Звантаження</CenterScreenComponent>;
    }

    return (
        <div>
            <h3>Редагування документу</h3>
            <DocumentForm initialValues={initialValues} isEditingDocument attachmentIds={attachmentIds} id={id} />
        </div>
    );
};
